import React from 'react';
import { createStyles } from '@/contexts/theme-context';
import { StyleSheet, View } from 'react-native';
import { Typography } from '@usepepper/ui/atoms/typography';

const DEFAULT_BADGE_SIZE = 16;

interface KeyboardShortcutBadgeProps {
  shortcut: string;
  size?: number;
}

export const KeyboardShortcutBadge: React.FC<KeyboardShortcutBadgeProps> = ({
  shortcut,
  size = DEFAULT_BADGE_SIZE,
}) => {
  const [styles, theme] = useStyles();

  return (
    <View
      style={StyleSheet.flatten([styles.badge, { height: size, width: size }])}
    >
      <Typography color={theme.sk.color.text.tertiary} variant="paragraph-sm">
        {shortcut.toUpperCase()}
      </Typography>
    </View>
  );
};

const useStyles = createStyles((theme) => ({
  badge: {
    alignItems: 'center',
    backgroundColor: theme.sk.color.bg.primary.hover,
    borderColor: theme.sk.color.border.primary,
    borderRadius: theme.sk.radii.radiusSmall,
    borderWidth: 1,
    justifyContent: 'center',
  },
}));
